import kebabCase from 'lodash/kebabCase'

export default filePath => {
  const fileName = filePath.split('/').pop()
  return kebabCase(fileName.replace(/\.js$|\.vue|\.svg$/, ''))
}